import http from '../config/http';
import routes from '../config/api_routes';


export const get = page => {
    let props = {}
    props.page= page;
    props.complete = true;
    return http().get(routes.images.getImage, {
        params: props
    });
}
